import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { trackHotspotEvent } from '../utils/hotspotEvents';
import './Profile.css';

const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.tocoroyo.poppygrid.prod';
const IOS_URL = 'https://apps.apple.com/app/id6755103014';

function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isMobile() {
  return isAndroid() || isIOS();
}

export default function Hotspot() {
  const { hotspotId } = useParams();
  const [autoRedirect, setAutoRedirect] = useState(false);
  const deepLink = `poppygrid://Hotspot/${hotspotId}`;
  const storeUrl = isAndroid() ? ANDROID_URL : isIOS() ? IOS_URL : null;

  useEffect(() => {
    if (hotspotId) {
      trackHotspotEvent(hotspotId, 'SCAN');
    }
  }, [hotspotId]);

  // Auto-redirect pattern for both Android and iOS
  // Try to open the app, if not installed redirect to store
  useEffect(() => {
    if (isMobile() && storeUrl) {
      let timeout;
      let appOpened = false;
      let appOpenLogged = false;

      const logAppOpen = () => {
        if (!appOpenLogged && hotspotId) {
          appOpenLogged = true;
          trackHotspotEvent(hotspotId, 'APP_OPEN');
        }
      };

      const logStoreRedirect = () => {
        if (hotspotId) {
          trackHotspotEvent(hotspotId, 'STORE_REDIRECT');
        }
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
          logAppOpen();
          if (timeout) {
            clearTimeout(timeout);
          }
        }
      };

      if (isIOS()) {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        if (document.hidden) {
          appOpened = true;
          logAppOpen();
        }
      }

      window.location.href = deepLink;

      timeout = setTimeout(() => {
        if (!appOpened) {
          logStoreRedirect();
          setAutoRedirect(true);
          window.location.href = storeUrl;
        }
      }, isIOS() ? 1500 : 1000);

      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
        if (isIOS()) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
      };
    }
  }, [deepLink, storeUrl, hotspotId]);

  const handleStoreClick = () => {
    if (hotspotId) {
      trackHotspotEvent(hotspotId, 'STORE_REDIRECT');
    }
  };

  if (autoRedirect) {
    return (
      <div className="profile-container">
        <div className="profile-content">
          <p>Redirecting to app store...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h1>PoppyGrid Hotspot</h1>
        <p className="profile-message">
          To view this hotspot, open it in the PoppyGrid app.
        </p>

        <div className="profile-actions">
          <a
            href={deepLink}
            className="action-button primary"
          >
            Open in App
          </a>

          {isAndroid() && (
            <a
              href={ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="action-button"
              onClick={handleStoreClick}
            >
              Get it on Google Play
            </a>
          )}

          {isIOS() && (
            <a
              href={IOS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="action-button"
              onClick={handleStoreClick}
            >
              Download on App Store
            </a>
          )}

          {!isMobile() && (
            <>
              <a
                href={ANDROID_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="action-button"
                onClick={handleStoreClick}
              >
                Get it on Google Play
              </a>
              <a
                href={IOS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="action-button"
                onClick={handleStoreClick}
              >
                Download on App Store
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
